import React, { Component } from 'react';
import Cons from '../../../../isomorphic/cons';

export default class StepActionButtons extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const isComplete = this.props.step.state.isComplete,
            isNA = this.props.step.state.isMarkedNotApplicable,
            hideNaAction = this.props.hideNaAction,
            hideWaitingAction = this.props.hideWaitingAction;
        return isComplete ? null : (
            <div className="" style={{ padding: 0, marginBottom: 10 }}>
                <button
                    className="btn btn-default "
                    style={{ marginRight: 10, display: isNA || hideWaitingAction ? 'none' : 'inline' }}
                    onClick={this.props.viewStore.showWaitingModal}
                >
                    Mark as Waiting
                </button>
                <button
                    className="btn btn-default "
                    style={{ display: hideNaAction ? 'none' : 'inline' }}
                    onClick={this.props.viewStore.showNaModal}
                >
                    {isNA ? 'Mark as Applicable' : 'Mark as N/A'}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/components/step-actions.js